import { FC, ReactElement } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/resources/queryClient';

type ReactQueryClientProviderProps = {
  children: ReactElement;
};

export const ReactQueryClientProvider: FC<ReactQueryClientProviderProps> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
